import type {
  FormattedMemberReferrals,
  MemberReferralsAPIRequest,
  MemberReferralsAPIResponse
} from '@library/types/members/memberReferrals';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { defaultHeaders } from '@bo-constants/apiHeaders';
import { transformMemberReferrals } from '@bo-utils/members/memberReferrals';

const { member } = apiPaths;

export const memberReferralsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMemberReferrals: build.query<
      FormattedMemberReferrals | undefined,
      MemberReferralsAPIRequest
    >({
      query: ({ memberId, page, perPage }) => ({
        url: `${member}/${memberId}/user_referrals`,
        method: 'GET',
        params: {
          page,
          per_page: perPage
        },
        headers: defaultHeaders
      }),
      transformResponse: (response: MemberReferralsAPIResponse) => {
        return transformMemberReferrals({ response });
      },
      providesTags: ['MemberReferrals']
    })
  })
});

export const { useGetMemberReferralsQuery } = memberReferralsApi;
